import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  nameField: {
    margin: theme.spacing(0, 0, 2, 0),
  },
  statusField: {
    margin: theme.spacing(0, 0, 2, 0),
  },
}));